import React, {useContext, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {TitleAndContentLayout} from "./TitleAndContentLayout";
import {TenantResource} from "../enums/TenantResource";
import {ITenantColumn, ITenantFormLayout, TextFieldElement,} from "./OnixElements";
import {PersonalVehicle} from "../API";
import {AuthContext} from "../contexts/AuthContext";
import {TenantList} from "./TenantList";

export const UserSettingsPersonalVehicles = () => {
    const {t} = useTranslation();
    const {UserInfo} = useContext(AuthContext);

    const columns: ITenantColumn<PersonalVehicle>[] = useMemo(
        () => [
            {
                fieldName: "makeAndModel",
                minWidth: 200,
                name: t("makeAndModel"),
                key: "makeAndModel",
            },
            {
                fieldName: "registration",
                minWidth: 200,
                name: t("registration"),
                key: "registration",
            },
        ],
        [t],
    );

    const form: ITenantFormLayout<PersonalVehicle> = useMemo(
        () => ({
            makeAndModel: {
                type: new TextFieldElement({}),
            },
            registration: {
                type: new TextFieldElement({}),
            },
        }),
        [],
    );

    return (
        <TitleAndContentLayout
            title={"personal-vehicles"}
            lessPadding
            isSubtitle
            pad
        >
            <TenantList
                resource={TenantResource.PersonalVehicle}
                addingTitle={"adding-new-personal-vehicle"}
                editingTitle={"editing-new-personal-vehicle"}
                form={form}
                baseDto={{
                    applicationUserId: UserInfo?.user?.id,
                }}
                queryIsRequired
                query={{applicationUserId: {Equals: UserInfo?.user?.id}}}
                columns={columns}
            />
        </TitleAndContentLayout>
    );
};
